export default {
  domain_not_found:
    "We couldn’t find a tenant at this address. Please check the web address (URL) and try again.",
  not_configured:
    "We are experiencing technical issues with your request, please contact technical support.",
  network_error:
    "We could not connect to the server (Network Error).\nPlease check your internet connection.\nIf you are on a work or school network, your firewall may be blocking access to this site — check with your IT team.\nIf the problem continues, contact technical support.",
  chart_configuration_error:
    "Unknown Chart Type. Please Contact Tech Support for Configuration Assistance",
};
